import { createQuery } from 'QueryKit'
import { getImageMeasurementsFiltered } from 'API/definitions/iris/measurement'

const useGetImageMeasurementsFiltered = createQuery<any, any, Error>({
  primaryKey: 'image-measurements-filtered',
  queryFn: ({ queryKey: [primaryKey, variables] }) => {
    return getImageMeasurementsFiltered(variables?.filterQueryParams)
  },
})

export { useGetImageMeasurementsFiltered }
